import { GLOBAL } from 'saddlebag-browser';

const replaceUrlSearch = (search: string): void => {
  const window = GLOBAL.getWindow();
  if (typeof window.history.replaceState === 'function') {
    window.history.replaceState({}, '', search);
  }
};

export default replaceUrlSearch;
